import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
type Crumb = {
  label: string;
  to?: string;
};
type PageHeroProps = {
  eyebrow: string;
  title: string;
  description?: string;
  image: string;
  breadcrumb: Crumb[];
};
export function PageHero({
  eyebrow,
  title,
  description,
  image,
  breadcrumb
}: PageHeroProps) {
  return <section className="relative w-full overflow-hidden bg-navy" data-id="element-75" data-mp="pt3dry6bo4p1">
      <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" aria-hidden="true" data-id="element-76" data-mp="ptlfvbfo1d4v" />
      <div className="absolute inset-0 bg-navy/70" aria-hidden="true" data-id="element-77" data-mp="g3tm2jfe4o1g" />

      <div className="relative mx-auto max-w-7xl px-6 py-20 lg:py-28" data-id="element-78" data-mp="l2d8sm1t63uv">
        <nav aria-label="Breadcrumb" data-id="element-79" data-mp="l0k1d4jdfflt">
          <ol className="flex flex-wrap items-center gap-2 text-[12px] font-semibold uppercase tracking-widest text-white/60" data-id="element-80" data-mp="18s7kv1eazoe2">
            {breadcrumb.map((crumb, index) => <li key={crumb.label} className="flex items-center gap-2" data-id="element-81" data-mp="1dkiks491na6m" data-mpi={index}>
                {crumb.to ? <Link to={crumb.to} className="transition-colors hover:text-gold-light" data-id="element-82" data-mp="32fzhriskzk7h">
                    {crumb.label}
                  </Link> : <span className="text-gold-light" data-id="element-83" data-mp="3c9g7aaloqd5c">{crumb.label}</span>}
                {index < breadcrumb.length - 1 && <ChevronRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-84" data-mp="3l8jspl8br4n0" />}
              </li>)}
          </ol>
        </nav>

        <p className="mt-8 font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gold" data-id="element-85" data-mp="3g9gxesi5ccs8">
          {eyebrow}
        </p>
        <h1 className="mt-3 max-w-3xl font-display text-4xl font-black uppercase leading-[1.1] tracking-tight text-white sm:text-5xl" data-id="element-86" data-mp="3q7wnqt9cni0o">
          {title}
        </h1>
        {description && <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-white/80" data-id="element-87" data-mp="1vtvgbjzqhmoz">
            {description}
          </p>}
      </div>
    </section>;
}